/**
 * Live Customizer Drawer & Valentine State Manager
 */
export class ValentineCustomizer {
  constructor() {
    this.drawer = document.getElementById('customizer-drawer');
    this.openBtn = document.getElementById('open-customizer-btn');
    this.closeBtn = document.getElementById('close-customizer-btn');
    this.saveBtn = document.getElementById('save-customizer-btn');
    this.copyShareBtn = document.getElementById('copy-share-btn');

    this.partner1Input = document.getElementById('input-partner1');
    this.partner2Input = document.getElementById('input-partner2');
    this.dateInput = document.getElementById('input-date');
    this.messageInput = document.getElementById('input-message');
    this.secretInput = document.getElementById('input-secret');

    this.initData();
    this.bindEvents();
    this.applyToDOM();
  }

  initData() {
    // Check URL params first, then localStorage, then default
    const params = new URLSearchParams(window.location.search);
    this.data = {
      partner1: params.get('p1') || localStorage.getItem('val_p1') || 'Aarav',
      partner2: params.get('p2') || localStorage.getItem('val_p2') || 'Meera',
      date: params.get('date') || localStorage.getItem('val_date') || 'February 14, 2026',
      message: params.get('msg') || localStorage.getItem('val_msg') || 'In a world full of temporary things, you are a perpetual feeling of home.',
      secret: params.get('sec') || localStorage.getItem('val_sec') || 'I knew I loved you the moment I realized my favorite place in the whole world was simply by your side.'
    };

    if (this.partner1Input) this.partner1Input.value = this.data.partner1;
    if (this.partner2Input) this.partner2Input.value = this.data.partner2;
    if (this.dateInput) this.dateInput.value = this.data.date;
    if (this.messageInput) this.messageInput.value = this.data.message;
    if (this.secretInput) this.secretInput.value = this.data.secret;
  }

  bindEvents() {
    if (this.openBtn && this.drawer) {
      this.openBtn.addEventListener('click', () => {
        this.drawer.classList.add('is-open');
      });
    }

    if (this.closeBtn && this.drawer) {
      this.closeBtn.addEventListener('click', () => {
        this.drawer.classList.remove('is-open');
      });
    }

    if (this.saveBtn) {
      this.saveBtn.addEventListener('click', () => {
        this.saveData();
        this.applyToDOM();
        if (this.drawer) this.drawer.classList.remove('is-open');
      });
    }

    if (this.copyShareBtn) {
      this.copyShareBtn.addEventListener('click', () => {
        this.saveData();
        const url = new URL(window.location.href);
        url.searchParams.set('p1', this.data.partner1);
        url.searchParams.set('p2', this.data.partner2);
        url.searchParams.set('date', this.data.date);
        url.searchParams.set('msg', this.data.message);
        url.searchParams.set('sec', this.data.secret);

        navigator.clipboard.writeText(url.toString()).then(() => {
          const originalText = this.copyShareBtn.innerText;
          this.copyShareBtn.innerText = '✨ Link Copied to Clipboard!';
          setTimeout(() => {
            this.copyShareBtn.innerText = originalText;
          }, 2500);
        });
      });
    }
  }

  saveData() {
    if (this.partner1Input) this.data.partner1 = this.partner1Input.value.trim() || 'Aarav';
    if (this.partner2Input) this.data.partner2 = this.partner2Input.value.trim() || 'Meera';
    if (this.dateInput) this.data.date = this.dateInput.value.trim() || 'February 14, 2026';
    if (this.messageInput) this.data.message = this.messageInput.value.trim() || this.data.message;
    if (this.secretInput) this.data.secret = this.secretInput.value.trim() || this.data.secret;

    localStorage.setItem('val_p1', this.data.partner1);
    localStorage.setItem('val_p2', this.data.partner2);
    localStorage.setItem('val_date', this.data.date);
    localStorage.setItem('val_msg', this.data.message);
    localStorage.setItem('val_sec', this.data.secret);
  }

  applyToDOM() {
    const p1Els = document.querySelectorAll('.bind-partner1');
    p1Els.forEach(el => el.textContent = this.data.partner1);

    const p2Els = document.querySelectorAll('.bind-partner2');
    p2Els.forEach(el => el.textContent = this.data.partner2);

    const coupleEls = document.querySelectorAll('.bind-couple');
    coupleEls.forEach(el => el.textContent = `${this.data.partner1} & ${this.data.partner2}`);

    const dateEls = document.querySelectorAll('.bind-date');
    dateEls.forEach(el => el.textContent = this.data.date);

    const msgEls = document.querySelectorAll('.bind-message');
    msgEls.forEach(el => el.textContent = this.data.message);

    const secEls = document.querySelectorAll('.bind-secret');
    secEls.forEach(el => el.textContent = this.data.secret);
  }
}
